import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { SocietyInviteBanner } from './SocietyInviteBanner'
import { userQueries } from '../../../../api/users'
import { usePreApprovedList } from '../../../../hooks/usePreApprovedList'
import { useAuth } from '../../../../hooks/useAuth'

export const SocietyInvites = (): React.ReactNode => {
  const { userId } = useAuth()
  const { data: user } = useQuery(userQueries.getUser(userId))

  const preApprovedList = usePreApprovedList()
  if (!user) {
    return null
  }
  return (
    <div className="w-full space-y-1">
      {preApprovedList?.map((_preApproved) => {
        return (
          <SocietyInviteBanner
            key={_preApproved._id}
            preApproved={_preApproved}
          />
        )
      })}
    </div>
  )
}
